export default __webpack_public_path__ + "static/media/green.596b6d83.png";